import { html } from 'lit-html';
import { ItemRequestSubmitAction } from '../actions/item_request_submit_action'

export const Button = () => html`
<button class="m-btn -short" type="button" data-micromodal-close="true">
  <span class="m-btn_inner"><span class="m-btn_text">閉じる</span></span>
</button>
<button class="m-btn -primary -short is-disabled" type="submit" id="btn_item_request"
 style="width: 185px;"
  @click="${() => ItemRequestSubmitAction.sendItemRequest()}"
>
  <span class="m-btn_inner">
    <span class="m-btn_text">リクエスト送信</span>
  </span>
</button>
`;
